"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
require("firebase/firebase-firestore");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
function Posts(props) {
    var _a;
    var snapshot = (0, firestore_1.useCollection)(collectionsRef_1.discussionsRef.where('documentType', '==', props.documentType).where('documentId', '==', props.docId))[0];
    if (!snapshot) {
        return null;
    }
    var data = ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (doc) { return (__assign(__assign({}, doc.data()), { id: doc.id })); });
    var sortedSnapshot = (0, lodash_1.sortBy)(data, function (item) { return item.createdAt.toDate(); }).reverse();
    var dataSource = sortedSnapshot.map(function (item) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: props.style }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        WebkitBoxPack: 'start',
                        justifyContent: 'flex-start',
                        fontSize: '14px',
                        alignItems: 'center',
                    } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                fontSize: '14px',
                                lineHeight: '14px',
                                marginRight: '10px',
                                fontFamily: 'initial',
                            } }, { children: (0, jsx_runtime_1.jsx)("a", { children: usersList_1.globalUsersData[item.userId].name }) })), (0, jsx_runtime_1.jsx)("span", __assign({ style: { fontSize: '12px', color: '#ccc', whiteSpace: 'nowrap' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.createdAt.toDate().toLocaleString() }) }))] })), (0, jsx_runtime_1.jsx)("div", { style: { marginTop: 10 }, dangerouslySetInnerHTML: { __html: item.body } })] }), item.id));
    });
    return (0, jsx_runtime_1.jsx)("div", { children: dataSource });
}
exports.default = Posts;
